/*
 * 通用混入viewForm 详情页面
 */
// import { commonApi } from '@/api';
import moment from 'moment';
import { downloadImageUrl, isCrossDomainDownloadUrl, normalizeDownloadUrl, openDownloadUrl } from '@/utils/index';
export default {
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    isView: {
      type: Boolean,
      default: false,
    },
    isAdd: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pageName: 'page_list_router_name',
    };
  },
  filters: {
    profitMarginFilter(val) {
      if (val) {
        const result = Number((val * 100).toFixed(2));
        return `${result}%`;
      } else {
        return `0%`;
      }
    },
    timeOperateTwoHour(date) {
      if (date) {
        // 获取澳洲当前时间与本地时间的时差
        const timeHour = sessionStorage.getItem('timeHour') || '2';
        var time = Date.parse(new Date(date));
        var newTime = moment(time + timeHour * 3600000).format('DD/MM/YYYY HH:mm');
        return newTime;
      }
    },
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {

  },
  beforeDestroy() {},
  methods: {
    jumper(ARG_ROUTER, GO_BY_NAME = false) {
      const view = this.$route;
      let page = this.pageName;
      // 跳转到 route.name
      GO_BY_NAME = GO_BY_NAME === true;

      if (typeof ARG_ROUTER == 'string') {
        page = ARG_ROUTER;
      }
      if (ARG_ROUTER && typeof ARG_ROUTER.name == 'string') {
        page = ARG_ROUTER.name;
      }
      if (!GO_BY_NAME) this.$router.go(-1);
      this.$store.dispatch('tagsView/closeCurrentView', view).then(() => {
        // 目标路由 pageName
        //    1. 如果有被缓存，就调用 eventHub 的 刷新数据
        //    2. 如果没有被缓存，无需手动刷新。（防止多次API请求）
        const hasCached = this.$store.state.tagsView.cachedViews.map(e => e.name).includes(page);
        if (GO_BY_NAME) this.$router.push({ name: page }); // 【返回功能】 暂时使用router.go(-1)，不指定返回到router.name
        if (hasCached) {
          setTimeout(() => {
            this.$eventHub.$emit('refresh' + page, 1);
          }, 500);
        }
      });
    },
    // 完成后，按routerName跳转
    complete(ARG_ROUTER) {
      this.jumper(ARG_ROUTER, true);
    },
    // 取消/返回  上一页
    cancel(ARG_ROUTER) {
      this.jumper(ARG_ROUTER, false);
    },
    // 弹窗确定后，再取消/返回  上一页
    tryCancel(ARG_ROUTER, title = this.$t('WorkflowDesign.form.cancel')) {
      this.$confirm(title, this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.cancel(ARG_ROUTER);
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('WorkflowDesign.form.cancel1'),
          });
        });
    },
    goBack(path) {
      this.$store.dispatch('tagsView/closeCurrentView', this.$route).then(() => {
        this.$router.push(path);
      });
    },
    normalizeDownloadUrl,
    isCrossDomainDownloadUrl,
    openDownloadUrl,
    downloadImageUrl,
  },
};
